import { IceDashboardDisplayStateEnum } from 'dashboard/enums/visuals/ice-dashboard-display-state.enum';
import {
    VisualsDashboardBackgroundColorEnum,
    VisualsDashboardRangesColorEnum,
    VisualsDashboardTextColorEnum,
} from 'dashboard/enums/visuals/visuals-dashboard-colors.enum';

export const StateToAccentColorMap: Record<IceDashboardDisplayStateEnum, VisualsDashboardRangesColorEnum> = {
    [IceDashboardDisplayStateEnum.SUCCESS]: VisualsDashboardRangesColorEnum.EMERALD,
    [IceDashboardDisplayStateEnum.WARNING]: VisualsDashboardRangesColorEnum.AMBER,
    [IceDashboardDisplayStateEnum.DANGER]: VisualsDashboardRangesColorEnum.RED,
    [IceDashboardDisplayStateEnum.NEUTRAL]: VisualsDashboardRangesColorEnum.LIME,
};

export const StateToTextColorMap: Record<IceDashboardDisplayStateEnum, VisualsDashboardTextColorEnum> = {
    [IceDashboardDisplayStateEnum.SUCCESS]: VisualsDashboardTextColorEnum.EMERALD,
    [IceDashboardDisplayStateEnum.WARNING]: VisualsDashboardTextColorEnum.AMBER,
    [IceDashboardDisplayStateEnum.DANGER]: VisualsDashboardTextColorEnum.RED,
    [IceDashboardDisplayStateEnum.NEUTRAL]: VisualsDashboardTextColorEnum.LIME,
};

export const StateToBackgroundColorMap: Record<IceDashboardDisplayStateEnum, VisualsDashboardBackgroundColorEnum> = {
    [IceDashboardDisplayStateEnum.SUCCESS]: VisualsDashboardBackgroundColorEnum.EMERALD,
    [IceDashboardDisplayStateEnum.WARNING]: VisualsDashboardBackgroundColorEnum.AMBER,
    [IceDashboardDisplayStateEnum.DANGER]: VisualsDashboardBackgroundColorEnum.RED,
    [IceDashboardDisplayStateEnum.NEUTRAL]: VisualsDashboardBackgroundColorEnum.LIME,
};
